import {
  hasStringValue,
  isSelected,
  isMin,
  isMax,
  maxLengthNotExceeding,
  correctEmail,
  hasMinLength,
  correctPhoneNumber,
  requiredIfNotExpectedComparerValue,
  hasStringValueWithMaxLenght
} from "@utilities";

const tradeSecure = [
  {
    field: "clientBeneficiaries.0.data.tradeSecur",
    validation: isSelected
  }
];

const clientBeneficiaries = [
  {
    field: "clientBeneficiaries.$index.data.clientBenefName",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefSurname",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefId",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefAddress",
    validation: hasStringValueWithMaxLenght(100)
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefRegCountry",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefBirthDate",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefShare",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefShare",
    validation: isMin(0)
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefShare",
    validation: isMax(100)
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefTaxCountry",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefTaxId",
    compareField: "clientBeneficiaries.$index.data.clientBenefTaxCountry",
    validation: requiredIfNotExpectedComparerValue("LT")
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefCountry",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.otherClientBenefRegCountry",
    validation: isSelected
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefEmail",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefEmail",
    validation: correctEmail
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefIdDoc",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefDocNo",
    validation: maxLengthNotExceeding(20)
  },
  {
    field: "clientBeneficiaries.$index.data.beneficiaryFunds",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefPhoneNo",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefPhoneNo",
    validation: correctPhoneNumber
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefPhoneNo",
    validation: hasMinLength(8)
  },
  {
    field: "clientBeneficiaries.$index.data.clientBenefPhoneNo",
    validation: maxLengthNotExceeding(20)
  }
];

const otherBenefCountry = [
  {
    field: "clientBeneficiaries.$index.data.otherClientBenefRegDocType",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.otherClientBenefRegDocNo",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.otherClientBenefRegDocNo",
    validation: maxLengthNotExceeding(20)
  },
  {
    field: "clientBeneficiaries.$index.data.otherClientBenefRegDocCountry",
    validation: hasStringValue
  },
  {
    field: "clientBeneficiaries.$index.data.otherClientBenefRegCountSch",
    validation: isSelected
  }
];

export const getStep5Validations = ({ totalBeneficiaries, clientBeneficiariesValues }) => {
  const benefValidationsMapped = [...tradeSecure];

  for (let i = 0; i < totalBeneficiaries; i++) {
    const isOtherBenefCountrySelected =
      clientBeneficiariesValues[i].data.otherClientBenefRegCountry === 1 ||
      clientBeneficiariesValues[i].data.otherClientBenefRegCountry === "1";

    if (isOtherBenefCountrySelected) {
      otherBenefCountry.forEach(({ field, validation }) => {
        benefValidationsMapped.push({
          field: field.replace("$index", i),
          validation
        });
      });
    }

    clientBeneficiaries.forEach(({ field, validation, compareField }) => {
      benefValidationsMapped.push({
        field: field.replace("$index", i),
        validation,
        ...(compareField && { compareField: compareField.replace("$index", i) })
      });
    });
  }
  return benefValidationsMapped;
};
